import {OpenPrivacyCommandHandler} from './open-privacy.command-handler';
import {DomainCommand} from '../../modules/command-bus/command';

export class OpenPrivacyCommand extends DomainCommand {
  constructor() {
    super(OpenPrivacyCommandHandler);
  }
}
